import React, { Component } from 'react'
import {
  Paper,
  IconButton,
  Button,
  CircularProgress,
  TextField,
  TableHead,
  Dialog,
  Table,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  TablePagination
} from '@material-ui/core'
import moment from 'moment'
import axios from 'axios'
import { FB_API_URL } from '../lib/env'
import ClearIcon from '@material-ui/icons/Clear'
import MogoLogo from '../img/mogo_logo.png'
import EurasianLogo from '../img/eurasian_logo.png'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import SearchIcon from '@material-ui/icons/Search'
import TablePaginationActions from '../components/table_pagination_actions'
import CustomNumberFormatNoSeparator from '../components/custom_number_format_noseparator'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import CreateCreditRequest from './create_credit_request'
import CreditRequest from './CreditRequest'
import Slide from '@material-ui/core/Slide'
import { withSnackbar } from 'notistack'
import { flowRight } from 'lodash'
import ErrorModal from '../asterX-UIkit/modals/ErrorModal'

let timer = null

class CreditRequestProcessing extends Component {
  constructor(props) {
    super(props)

    this.state = {
      creditRequests: [],
      seoNumber: '',
      token: localStorage.getItem('token'),
      finOrgName: null,
      isLoading: false,
      countFilterRequests: 0,
      filterAllRequests: 0,
      currentPage: 0,
      rowsPerPage: 10,
      selectedBranch: '',
      selectedBank: '',
      selectedStatus: 'all',
      filterBank: '',
      username: '',
      clientIIN: '',
      filterStartDate: moment(new Date()).subtract(1, 'week').toDate(),
      isNewCreditRequestDialogOpen: false,
      filterEndDate: new Date(),
      error: false
    }
  }

  componentDidMount() {
    this.getCreditRequests()
    timer = setInterval(() => {
      this.getCreditRequests()
    }, 300000)
  }

  componentWillUnmount() {
    clearInterval(timer)
  }

  getCreditRequests(offset = 0, limit = 10) {
    this.setState({ isLoading: true })
    let self = this

    let data = {
      offset: offset,
      limit: limit
    }

    data.createdDateFrom = moment(this.state.filterStartDate).format(
      'YYYY-MM-DD'
    )
    data.createdDateTo = moment(this.state.filterEndDate).format('YYYY-MM-DD')

    if (this.state.clientIIN !== '' && this.state.clientIIN !== null) {
      data.clientIIN = this.state.clientIIN
    }

    axios
      .get(
        FB_API_URL +
          '/finbroker/credit_request/filter/?offset=' +
          offset +
          '&limit=' +
          limit +
          '&startDate=' +
          moment(this.state.filterStartDate).format('YYYY-MM-DD') +
          '&endDate=' +
          moment(this.state.filterEndDate).format('YYYY-MM-DD') +
          '&iin=' +
          this.state.clientIIN +
          '&username=' +
          this.state.username +
          '&status=' +
          this.state.selectedStatus +
          '&branchCode=' +
          this.state.selectedBranch +
          '&bankSend=' +
          this.state.filterBank,
        {
          headers: { Authorization: `Bearer ${this.state.token}` }
        }
      )
      .then(function (response) {
        console.log(response.data)
        self.setState({
          isLoading: false,
          creditRequests: response.data.creditRequests,
          countFilterRequests: response.data.creditRequestsFilterCount,
          filterAllRequests: response.data.creditRequestsAllCount
        })
      })
      .catch(function (error) {
        self.setState({ isLoading: false })
        console.log(error.message)
        if (error.message.includes('403')) {
          self.setState({
            error: 'Доступ в данный раздел запрещен!'
          })
          self.props.history.push('/signin')
        }
      })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  handleChangeDate = name => date => {
    this.setState({
      [name]: date
    })
  }

  handleSearch() {
    this.setState(
      {
        currentPage: 0
      },
      () => {
        if (this.state.filterStartDate > this.state.filterEndDate) {
          this.setState({
            error: 'Дата начала не может быть после даты конца'
          })
        } else {
          this.getCreditRequests(0, this.state.rowsPerPage)
        }
      }
    )
  }

  handleResetFilter() {
    this.setState(
      {
        currentPage: 0,
        filterStartDate: moment(new Date()).subtract(1, 'months').toDate(),
        filterEndDate: moment(new Date()).toDate(),
        clientIIN: ''
      },
      () => {
        this.getCreditRequests(0, this.state.rowsPerPage)
      }
    )
  }

  handleChangePage(event, newPage) {
    this.setState(
      {
        currentPage: newPage
      },
      () => {
        let offset = newPage * this.state.rowsPerPage
        let limit = this.state.rowsPerPage
        this.getCreditRequests(offset, limit)
      }
    )
  }

  handleChangeRowsPerPage(event) {
    this.setState(
      {
        currentPage: 0,
        rowsPerPage: parseInt(event.target.value, 10)
      },
      () => {
        this.getCreditRequests(0, this.state.rowsPerPage)
      }
    )
  }

  downloadFile(creditRequestId, type) {
    axios
      .get(
        FB_API_URL +
          '/finbroker/credit_request/downloadFile/' +
          type +
          '/' +
          creditRequestId,
        {
          responseType: 'arraybuffer',
          headers: {
            Authorization: `Bearer ${this.state.token}`
          }
        }
      )
      .then(function (response) {
        console.log(response)
        let fileName = response.headers.pragma
        let fileExtension = fileName.split('.').pop()
        let blob = new Blob([response.data], {
          type: 'application/' + fileExtension
        })
        const downloadUrl = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = downloadUrl
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        //FileDownload(new Blob([response.data]), fileName);
      })
      .catch(function (error) {
        console.log(error.message)
      })
  }

  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <div style={{ display: 'inline-block' }}>
          <div
            style={{
              display: 'flex',
              textAlign: 'left',
              flexDirection: 'column',
              flexWrap: 'wrap',
              margin: 'auto',
              flexBasis: '0'
            }}
          >
            <div style={{ textAlign: 'left' }}>
              {this.state.finOrgName === 'eurasian' && (
                <img
                  src={EurasianLogo}
                  height="40px"
                  style={{ marginTop: '10px', marginBottom: '10px' }}
                  alt="eurasian bank"
                />
              )}
              {this.state.finOrgName === 'mogo' && (
                <img src={MogoLogo} height="70px" alt="mogo" />
              )}
            </div>
            <div style={{ textAlign: 'left' }} className="title mobile_tr">
              Кредитные заявки Aster Auto
            </div>

            <Paper className="filter">
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div
                  style={{
                    marginTop: '14px',
                    width: '125px',
                    marginRight: '5px'
                  }}
                >
                  <TextField
                    label="ИИН"
                    value={this.state.clientIIN}
                    onChange={this.handleChange('clientIIN')}
                    InputProps={{
                      inputComponent: CustomNumberFormatNoSeparator,
                      className: 'textfield_green'
                    }}
                  />
                </div>
                <div style={{ width: '136px', marginRight: '5px' }}>
                  {' '}
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    variant="outlined"
                  >
                    <KeyboardDatePicker
                      margin="normal"
                      label="Дата начала"
                      format="dd.MM.yyyy"
                      value={this.state.filterStartDate}
                      onChange={this.handleChangeDate('filterStartDate')}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div style={{ width: '150px', marginRight: '5px' }}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    variant="outlined"
                  >
                    <KeyboardDatePicker
                      margin="normal"
                      label="Дата конца"
                      format="dd.MM.yyyy"
                      value={this.state.filterEndDate}
                      onChange={this.handleChangeDate('filterEndDate')}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div style={{ marginTop: '20px', marginRight: '10px' }}>
                  <Button
                    className="button_small button_green_color"
                    style={{ marginTop: '10px', paddingLeft: '10px' }}
                    color="primary"
                    variant="contained"
                    onClick={this.handleSearch.bind(this)}
                  >
                    <SearchIcon
                      style={{ fontSize: '18px', marginRight: '5px' }}
                    />
                  </Button>
                </div>
                <div style={{ marginTop: '20px' }}>
                  <Button
                    className="button_small button_grey_color"
                    style={{
                      marginTop: '10px',
                      paddingLeft: '10px',
                      backgroundColor: '#ff5733 ',
                      color: '#FFF'
                    }}
                    onClick={this.handleResetFilter.bind(this)}
                    variant="contained"
                  >
                    <ClearIcon style={{ fontSize: '18px' }} />
                  </Button>
                </div>
                <div style={{ marginTop: '20px' }}>
                  <Button
                    className="button_green_color button_small"
                    style={{
                      marginTop: '10px',
                      marginLeft: '10px',
                      paddingLeft: '10px'
                    }}
                    onClick={() =>
                      this.setState({ isNewCreditRequestDialogOpen: true })
                    }
                  >
                    Новая кредитная заявка
                  </Button>
                </div>
              </div>
            </Paper>

            {this.state.isLoading ? (
              <div style={{ padding: '20px' }}>
                <CircularProgress />
              </div>
            ) : (
              <div>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TablePagination
                        style={{ fontSize: '16px' }}
                        rowsPerPageOptions={[10, 50, 100]}
                        colSpan={14}
                        count={this.state.filterAllRequests}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.currentPage}
                        labelRowsPerPage={''}
                        labelDisplayedRows={({ from, to, count }) =>
                          `${from}-${to} из ${count}`
                        }
                        SelectProps={{
                          inputProps: { 'aria-label': 'Кол' },
                          native: true
                        }}
                        onChangePage={this.handleChangePage.bind(this)}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage.bind(
                          this
                        )}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.creditRequests.length === 0 && (
                      <TableRow>
                        <TableCell
                          style={{ borderBottom: 'none', padding: '0px' }}
                        >
                          <span style={{ fontSize: '18px' }}>Нет данных</span>
                        </TableCell>
                      </TableRow>
                    )}

                    {this.state.creditRequests.map(creditRequest => (
                      <TableRow key={creditRequest.id}>
                        <TableCell
                          style={{ borderBottom: 'none', padding: '0px' }}
                        >
                          <CreditRequest
                            key={creditRequest.id}
                            onClick={() =>
                              this.setState({
                                selectedCreditRequestForView: creditRequest
                              })
                            }
                            getCreditRequests={this.getCreditRequests.bind(
                              this
                            )}
                            creditRequest={creditRequest}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter align="left" style={{ align: 'left' }}>
                    <TableRow align="left" style={{ align: 'left' }}>
                      <TablePagination
                        rowsPerPageOptions={[10, 50, 100]}
                        colSpan={14}
                        count={this.state.filterAllRequests}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.currentPage}
                        labelRowsPerPage={''}
                        labelDisplayedRows={({ from, to, count }) =>
                          `${from}-${to} из ${count}`
                        }
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'Кол-во строк на странице'
                          },
                          native: true
                        }}
                        onChangePage={this.handleChangePage.bind(this)}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage.bind(
                          this
                        )}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </div>
            )}
          </div>
        </div>
        {this.state.isNewCreditRequestDialogOpen && (
          <Dialog
            open={this.state.isNewCreditRequestDialogOpen}
            fullScreen
            TransitionComponent={Transition}
          >
            <AppBar
              style={{ position: 'fixed', height: '80px', marginTop: '-10px' }}
            >
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({ isNewCreditRequestDialogOpen: false })
                    //this.getCreditRequests(this.props.sale.client.clientId)
                  }}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6">Кредитная заявка</Typography>
              </Toolbar>
            </AppBar>
            <div style={{ marginTop: '80px' }}>
              <CreateCreditRequest
                closeDialog={() => {
                  this.setState({ isNewCreditRequestDialogOpen: false })
                  //this.getCreditRequests(this.props.sale.client.clientId)
                }}
                sale={this.props.sale}
              />
            </div>
          </Dialog>
        )}
        <ErrorModal
          e={this.state.error}
          close={() => this.setState({ error: false })}
          snackbar={true}
        />
      </div>
    )
  }
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />
})
export default flowRight(withSnackbar)(CreditRequestProcessing)
